module.exports = __webpack_public_path__ + "img/颜美荟.2a60f08.png";